<div class="w-full h-screen grid place-items-center">
  <div class="container">
    <div class="error-code">403</div>
    <h1 class="error-title">Access denied</h1>
    <p class="error-message">
      Sorry, you don't have permission to view this page. If you believe this is a mistake, please
      contact your administrator or try signing in with a different account.
    </p>
    <div class="actions">
      <button (click)="goBack()" class="btn btn-secondary">
        <svg class="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M10 19l-7-7m0 0l7-7m-7 7h18"
          />
        </svg>
        Go Back
      </button>
      <a (click)="goHome()" class="btn btn-primary">
        <svg class="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
          />
        </svg>
        Go Home
      </a>
    </div>
  </div>
</div>
